import React, { Component } from 'react';

import styles from 'assets/jss/material-dashboard-pro-react/customSelectStyle';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

class PageSizeSelect extends Component {
	render() {
		const {
			classes,
			pageSize,
			setPageSize,
		} = this.props;

		const numberOfRowsData = [5, 10, 15];

		return (
			<FormControl
				fullWidth
				className={`${classes.selectFormControl} ${classes.formControlMargins} ${classes.rowsPerPageControl}`}
			>
				<InputLabel
					htmlFor="simple-select"
					className={classes.selectLabel}
				>
					Rows per page
				</InputLabel>
				<Select
					MenuProps={{
						className: classes.selectMenu
					}}
					classes={{
						select: classes.select
					}}
					value={pageSize}
					onChange={event => {
						setPageSize(event.target.value);
					}}
					inputProps={{
						name: 'numberOfRows',
						id: 'number-of-rows'
					}}
				>
					{numberOfRowsData.map(prop => {
						return (
							<MenuItem
								key={prop}
								classes={{
									root: classes.selectMenuItem,
									selected: classes.selectMenuItemSelected
								}}
								value={prop}
							>
								{prop} rows
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		);
	}
}

export default withStyles(styles)(PageSizeSelect);
